import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { updateVarPoLine } from '../var/varSlice'
import Input from '../../components/abstractObjects/Input'
import { Label } from '../../components/abstractObjects/Label'

export const VarPoLineForm = (varPoLine, ImSupervisor) => {
    const dispatch = useDispatch()

    const [deliveryQuantityCorrected, setDeliveryQuantityCorrected] = useState({ value: varPoLine.DeliveryQuantityCorrected, error: null })
    const onDeliveryQuantityCorrectedChanged = (e) => {
        setDeliveryQuantityCorrected({ value: parseInt(e.target.value), error: null })
    }

    const updateObj = () => {
        if (!deliveryQuantityCorrected.value || deliveryQuantityCorrected.value == "" || deliveryQuantityCorrected.value == "NaN") {
            setDeliveryQuantityCorrected({ error: "Required!" })
            return false
        }
        dispatch(
            updateVarPoLine({
                Id: varPoLine.Id,
                DeliveryQuantityCorrected: deliveryQuantityCorrected.value,
                UpdatedServerDate: new Date().toISOString(),
                VarTransactionId: varPoLine.VarTransactionId
            })
        )
        return true
    }

    const ui = (
        <div key={varPoLine.Id}>
            <Label text="DELIVERY" style={{ fontWeight: "bold" }} /><Label text={varPoLine.DeliveryNumber} /><br />
            <Label text="ITEM" style={{ fontWeight: "bold" }} /><Label text={varPoLine.Poline} /><br />
            <Label text="DESCRIPTION" style={{ fontWeight: "bold" }} /><Label text={varPoLine.VaccineDescription} /><br />
            <Label text="DELIVERY_QUANTITY" style={{ fontWeight: "bold" }} /><Label text={varPoLine.DeliveryQuantity} /><br />
            <Label text="DELIVERY_QUANTITY_CORRECTED" style={{ fontWeight: "bold" }} /><Input type="number" value={deliveryQuantityCorrected.value} error={deliveryQuantityCorrected.error} onChange={onDeliveryQuantityCorrectedChanged} onKeyUp={updateObj} readonly={ImSupervisor} /><br /><br />
        </div>
    )

    return [ui, updateObj]
}

export default VarPoLineForm;